export const types = {
  SET_CURRENT_BANNER: "SET_CURRENT_BANNER",
  SET_BANNERS: "SET_BANNERS",
  SAVE_BANNER: "SAVE_BANNER",
  DELETE_BANNER: "DELETE_BANNER",
};
